import '@fontsource/inter'
import '@fontsource/inter/500.css'
import '@fontsource/inter/400.css'
import { ThemeProvider } from '@mui/material/styles'
import { LicenseInfo } from '@mui/x-license'
import { QueryClient, type QueryClientConfig, QueryClientProvider } from '@tanstack/react-query'
import '@total-typescript/ts-reset'
import DefaultMaterialTheme from 'helpers/DefaultMaterialTheme'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { FontLoader } from '@domains/subscription/theme'
import dayjs from 'dayjs'
import en from 'dayjs/locale/en'
import tz from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import ErrorBoundary from './routes/errorBoundary'
import { GlobalStyles } from './styles/globalStyles'

// dayjs.locale({ ...en, weekStart: 1 })
dayjs.extend(utc)
dayjs.extend(tz)

LicenseInfo.setLicenseKey(
  '07bb0f635785e48b73f24d1002433d2bTz0xMzI1NDIsRT0xODE5ODQzMTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTMsQVQ9c2luZ2xlLEtWPTI=',
)

const ReactQueryOptions: QueryClientConfig = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: 0,
      retry: false,
    },
  },
}

const Root = () => (
  <ThemeProvider theme={DefaultMaterialTheme}>
    <ErrorBoundary>
      <QueryClientProvider client={new QueryClient(ReactQueryOptions)}>
        <GlobalStyles />
        <FontLoader />
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </ThemeProvider>
)

createRoot(document.getElementById('root')!).render(<Root />)
